import co from 'co'; 

export default (self, gen) => {
    if (!gen) {
      gen  = self;
      self = this;
    }
    return co.call(self, gen).catch(window.onerror);
  };